import { apiClient } from "@/lib/apiClient";
import { apiPath } from "@/lib/apiPath";

export type RemindersOptoutResolve = {
  status: string;
  company_title: string;
  already_opted_out: boolean;
  /** "marketing": the link came with a salon's offer (boona clients CL6/CL7), not a reminder */
  kind?: "reminders" | "marketing";
};

/** Pure read for the confirm screen — the backend GET never mutates
 * (mail scanners prefetch footer links; return-reminders README §4.5). */
export async function resolveRemindersOptout(token: string): Promise<RemindersOptoutResolve> {
  const { data } = await apiClient.get(apiPath(`/reminders/optout/${token}`));
  return data;
}

export async function commitRemindersOptout(token: string) {
  const { data } = await apiClient.post(apiPath(`/reminders/optout/${token}`), {});
  return data;
}
